// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreApplications = (client) => ({
    /**
     * `GET /store/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetApplications
     * @source packages/modules/b2c-core/src/api/store/applications/route.ts
     */
    list: (query, headers) => client.fetch("/store/applications", { method: "GET", query, headers }),
    /**
     * `GET /store/applications/:id/categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreApplicationsIdCategoriesRetrieve
     * @source packages/modules/b2c-core/src/api/store/applications/[id]/categories/route.ts
     */
    listCategories: (id, query, headers) => client.fetch(buildPath("/store/applications/:id/categories", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreApplicationsIdProductsRetrieve
     * @source packages/modules/b2c-core/src/api/store/applications/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/store/applications/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetApplication
     * @source packages/modules/b2c-core/src/api/store/applications/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/applications/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/applications/:id/seo-content`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreApplicationsIdSeoContentRetrieve
     * @source packages/modules/b2c-core/src/api/store/applications/[id]/seo-content/route.ts
     */
    retrieveSeoContent: (id, query, headers) => client.fetch(buildPath("/store/applications/:id/seo-content", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=applications.js.map